module.exports = __webpack_public_path__ + "static/media/DaciaSpirit-Regular_V1000.e82bac96.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/spirit/DaciaSpirit-Regular_V1000.woff
// module id = 652
// module chunks = 0